module.exports = __webpack_public_path__ + "img/notice_card.06aea019.png";